<template>
  <div ref="videosContainer">
    <view-header header="Archiwum nagrań" />
    <div class="sort">
      <div class="sort__title">Sortuj według:</div>
      <div class="sort__option" :class="{ active: sortDesc }" @click="setSortOrder(true)">
        Od najnowszych
      </div>
      <div class="sort__option" :class="{ active: !sortDesc }" @click="setSortOrder(false)">
        Od najstarszych
      </div>
    </div>
    <div>
      <videos-item v-for="video in videos" :key="video.id" :video="video" />
    </div>
    <pagination
      :total-pages="totalPages"
      :per-page="itemsPerPage"
      :current-page="currentPage"
      @pagechanged="onPageChange"
    />
  </div>
</template>

<script>
  import VideosItem from '../components/VideosItem';
  import ViewHeader from '../components/ViewHeader';
  import Pagination from '../components/Pagination';

  import { PortalService } from '../utils/portal-service';

  export default {
    name: 'Videos',
    components: {
      ViewHeader,
      VideosItem,
      Pagination,
    },
    metaInfo: {
      meta: [
        { title: 'Portal | Archiwum nagrań' },
        { description: 'Portal | Archiwum nagrań' },
      ],
    },
    data() {
      return {
        currentPage: 1,
        itemsPerPage: 20,
        totalPages: 0,
        sortDesc: true,
        videos: [],
      };
    },
    async created() {
      await this.loadRecordings();
    },
    methods: {
      async onPageChange(page) {
        this.currentPage = page;

        await this.loadRecordings();
        window.scrollTo(0, 0);
      },

      async loadRecordings() {
        try {
          const params = {
            order: this.sortDesc ? 'desc' : 'asc',
            page: this.currentPage,
          };
          const { data } = await PortalService.getRecordings(params);
          this.videos = data['hydra:member'];
          this.itemsPerPage = data.perPage;
          this.currentPage = data.currentPage;
          this.totalPages = data.pages;
        } catch (err) {
          // pass
        }
      },

      async setSortOrder(isDesc) {
        this.sortDesc = isDesc;
        this.currentPage = 1;

        await this.loadRecordings();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sort {
    @include fontSize(18px);
    text-transform: uppercase;
    display: flex;
    justify-content: flex-end;
    flex-flow: wrap;
    color: $color--grey-0;
    margin-bottom: 30px;
    @at-root .high-contrast & {
      color: white;
    }

    @include mobile {
      justify-content: center;
    }

    &__title {
      padding-right: 16px;
      @include mobile {
        flex-basis: 100%;
        text-align: center;
      }
    }

    &__option {
      position: relative;

      @include mobile {
        flex: 1 1 0;
        max-width: 200px;
      }

      &.active,
      &:hover {
        cursor: pointer;
        color: $color--red;
        @at-root .high-contrast & {
          color: yellow;
        }
      }

      &:not(:last-child) {
        padding-right: 20px;

        &:after {
          content: '';
          position: absolute;
          height: 1rem;
          right: 8px;
          top: 0.3rem;
          width: 2px;
          background: #d0d0d0;
        }
      }
    }
  }
</style>
